/* THE ALLIANCE LEAGUE sponsor banner — native remake (no raster artifacts, crisp
   on every screen). Five partner emblems in circuit frames beside the league
   wordmark; shares the uniform banner-strip height with the other home strips. */
import { Link } from "react-router-dom";
import { Dna, Drumstick, Hexagon, RadioTower, Zap } from "lucide-react";

export const SPONSOR_META = [
  { slug: "bio-hack", icon: Dna, name: "BIO HACK", field: "GENETIC ENHANCEMENT" },
  { slug: "rad-burger", icon: Drumstick, name: "RAD BURGER", field: "ATOMIC TASTE" },
  { slug: "power-grid", icon: Zap, name: "THE POWER GRID", field: "ENERGIZING THE SECTORS" },
  { slug: "sectors", icon: Hexagon, name: "SECTORS 1-12", field: "UNIFIED URBAN REGIONS" },
  { slug: "wasteland-radio", icon: RadioTower, name: "WASTELAND RADIO", field: "GHOST TRANSMISSIONS" },
];

const Inner = ({ large }) => (
  <>
    <span className="alliance-banner-scan" aria-hidden="true" />
    <div className="alliance-banner-copy">
      <span className="alliance-banner-eyebrow">THE ALLIANCE LEAGUE — YEAR 2355</span>
      <strong>OFFICIAL SPONSORS</strong>
      <span className="alliance-banner-sub">OF THE AL RIOTBALL ARENA</span>
      {!large ? <span className="alliance-banner-cta">MEET THE SPONSORS →</span> : null}
    </div>
    <div className="alliance-banner-emblems" data-testid="alliance-banner-emblems">
      {SPONSOR_META.map((s) => (
        <span key={s.slug} className="alliance-emblem" data-testid={`alliance-emblem-${s.slug}`}>
          <span className="alliance-emblem-frame">
            <s.icon size={large ? 30 : 22} />
          </span>
          <span className="alliance-emblem-name">{s.name}</span>
          {large ? <span className="alliance-emblem-field">{s.field}</span> : null}
        </span>
      ))}
    </div>
  </>
);

export function AllianceSponsorsBanner({ large = false }) {
  if (large) {
    return (
      <div className="alliance-banner alliance-banner-large" data-testid="alliance-banner-large">
        <Inner large />
      </div>
    );
  }
  return (
    <Link to="/sponsors" className="alliance-banner" data-testid="alliance-home-banner" aria-label="Meet the Alliance League sponsors">
      <Inner large={false} />
    </Link>
  );
}
